import { useEffect, useRef, useState } from "react";
import TabBar from "../tabBar/TabBar";
import ProjectCard from "../projectCard/ProjectCard";
import { BP } from "../../util/constants/breakpoints";
import { AnimatePresence, motion } from "framer-motion";

export default function FilterTabView({
    namelist = [],
    initialTab = 0,
    tabTextStyle = {
        fontSize : "14px", //text-base
        letterSpacing : "0.1em", // tracking-wider
        fontWeight: 600, //semibold
    },
    indicatorSize = 8,
    items = [],
    filterCallbacks = [],
}) {


    const [currentTab, setCurrentTab] = useState(initialTab);

    useEffect(() => {
        if(namelist.length !== filterCallbacks.length){
            throw new Error("Number of names must be equal to number of filter callbacks!");
        }
    }, [namelist, filterCallbacks]);


    const [textSize, setTextSize] = useState(16);
    const [bgTextSize, setBgTextSize] = useState(75);
    const [boxSize, setBoxSize] = useState("325px");

    const onWindowWidthChange = () => {
        setTextSize(getTextSize());
        setBgTextSize(getBgTextSize());
        setBoxSize(getBoxSize());
    }

    const getBoxSize = () => {
        if(window.innerWidth < BP.xl) return "325px" 
        else return "450px" 
    }

    const getTextSize = () => {
        if(window.innerWidth < BP.xl) return 16 
        else return 20 
    }

    const getBgTextSize = () => {
        if(window.innerWidth < BP.xl) return 75 
        else return 110
    }

    useEffect(() => {
        setTextSize(getTextSize());
        setBgTextSize(getBgTextSize());
        setBoxSize(getBoxSize());
        window.addEventListener("resize", onWindowWidthChange)
        return () => window.removeEventListener("resize", onWindowWidthChange)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const getItemsArr = () => {

        let itemsArr = [];

        for(let i = 0; i < items.length; i++){
            if(filterCallbacks[currentTab](items[i])){

                itemsArr.push(
                    <motion.div
                        layout="position"
                        initial={{
                            opacity: 0,
                        }}
                        animate={{
                            opacity: 1,
                        }}
                        exit={{
                            opacity: 0,
                            transition: {
                                delay: 0
                            }
                        }}
                        transition={{
                            opacity: {
                                delay: 0.35,
                                duration: 0.3,
                            },
                            duration: 0.4,
                            ease: "anticipate",
                        }}
                        key={items[i].projectId}
                    >
                        <ProjectCard
                            project={items[i]}
                            boxSize={boxSize}
                            textSize={textSize}
                            bgTextSize={bgTextSize}
                        />
                    </motion.div> 
                );
            }
        }

        return itemsArr;

    }


    const ref = useRef();
    const [containerHeight, setContainerHeight] = useState("auto");

    useEffect(() => {
        if(ref.current){
            const resizeObserver = new ResizeObserver(() => {
                if(ref.current && ref.current.clientHeight){
                    const observedHeight = ref.current.clientHeight;
                    setContainerHeight(observedHeight);
                }
            });

            resizeObserver.observe(ref.current);

            return () => {
                resizeObserver.disconnect();
            }
        }
    }, []);

    return (
        <>

            <TabBar
                namelist={namelist}
                textStyle={tabTextStyle}
                getCurrentTabCallback={setCurrentTab}
                indicatorSize={indicatorSize}
                initialTab={initialTab}
             />

            <div
                className="
                    flex
                    justify-center
                    my-10
                    
                    transition-all
                    duration-500
                    ease-in-out
                "
                style={{
                    height: containerHeight 
                    // height: "auto" 
                }}
            >
                <div
                    ref={ref}
                    className="
                        grid
                        grid-cols-1
                        md:grid-cols-2
                        gap-10
                        xl:gap-24
                        justify-center
                        h-min
                    "
                >
                    <AnimatePresence mode="popLayout" initial={false}>
                        {
                            getItemsArr()
                        }
                    </AnimatePresence>
                </div>
            </div>

        </>
    );

}